import { ISection, ISectionTime } from '../../interfaces/scheduler_interfaces';
import { MeetingTimeServant } from '../meeting_times/servants/meeting_time_servant';
import * as _4 from 'lodash4';
import { ICommand } from 'core-ts-types';
import { CommunicatorService } from 'ui-ng-component-communicator';

export class MeetingTimesBannerController {
  private section: ISection;
  private hasMultipleMeetingTimes: boolean = false;
  private multipleMeetingCount: number;
  constructor(
    private ngMeetingTimeServant: MeetingTimeServant,
    private getSectionDetailsCommand: ICommand,
    private ngComponentCommunicatorService: CommunicatorService
  ) {}

  init() {
    this.hasMultipleMeetingTimes = this.ngMeetingTimeServant.hasMultipleMeetingTimes(this.section);
    this.multipleMeetingCount = this.ngMeetingTimeServant.getMultipleMeetingTimesCount(this.section);
  }

  $onChanges() {
    this.init();
  }

  openSectionDetail() {
    this.getSectionDetailsCommand(this.section.id).then(() =>
      this.ngComponentCommunicatorService.publish('OPEN_SECTION_DETAIL_MODAL')
    );
  }
}

angular.module('capability-ng-scheduler').component('meetingTimesBanner', {
  templateUrl: 'capability-ng-scheduler/src/components/meeting_times_banner/meeting_times_banner.html',
  controller: MeetingTimesBannerController,
  bindings: {
    section: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/meeting_times_banner/meeting_times_banner.ts